import { PageShell } from "@/components/sections";
import { Quote } from "lucide-react";

const Founder = () => (
  <PageShell>
    <section
      data-testid="founder-hero"
      className="relative bg-[var(--ld-ivory-warm)]/40 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12 pt-16 pb-20">
        <h1
          data-testid="founder-headline"
          className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[var(--ld-gold-deep)] leading-[1.05]"
        >
          Meet the founder
        </h1>

        <div className="mt-12 grid md:grid-cols-12 gap-10 md:gap-14 items-start">
          {/* Portrait */}
          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-[var(--ld-ink)]/5 md:sticky md:top-24">
              <img
                src="/founder.jpg"
                alt="Lux — Founder of Luxé Directory"
                data-testid="founder-portrait"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-[var(--ld-gold)]/25" />
            </div>
          </div>

          {/* Story */}
          <div className="md:col-span-7">
            <Quote
              size={32}
              strokeWidth={1.4}
              className="text-[var(--ld-gold-deep)]"
            />
            <p
              data-testid="founder-pull-quote"
              className="font-serif-display text-2xl sm:text-3xl leading-[1.4] text-[var(--ld-ink)] mt-6"
            >
              “Planning a Tamil or Hindu wedding shouldn&apos;t feel like detective
              work. Every couple deserves a quiet, considered place to start —
              and every vendor deserves a stage that matches their craft.”
            </p>

            <div className="mt-10 space-y-6 text-[15px] leading-[1.9] text-[var(--ld-ink)]">
              <p>
                Your business doesn&apos;t stop in the off-season — and neither do
                we. Our directory keeps you visible year-round, and our
                marketing support helps you grow even when weddings slow down.
              </p>
              <p>
                My name is Lux, and I founded Luxé Directory in 2025. I started
                it because I saw a gap in the industry. There were many
                well-known vendors, but there were also incredible small
                businesses and new vendors entering the wedding world. I wanted
                to create a platform where everyone had an equal chance to
                showcase their work.
              </p>
              <p>
                As a bride myself, I realised how difficult it can be to find
                the right vendors and to even know what options are out there.
                It&apos;s your big day — you want to choose the right people,
                because they shape the outcome and the entire vibe of the
                wedding.
              </p>
              <p>
                I love anything with a bit of a kick. And as a mental-health
                therapist, I know exactly what stress can do to you. Whether
                you&apos;re looking for clients or searching for vendors, the
                process can take a toll on your mental health. Through this
                directory, I combine my knowledge of psychology and marketing
                to help vendors present who they truly are, so couples know
                exactly what to expect and can book with confidence. That is
                why the platform is free for couples and vendors to join.
              </p>
              <p>
                If you&apos;re interested, I&apos;m not sure what you&apos;re waiting for.
                Head over to the Sign Up tab and join us!
              </p>
              <p>
                Every vendor here has been personally met or vetted. Every
                couple is welcomed with a complimentary intro. No noise. Just a directory built the way I
                wished one existed when I was the one searching.
              </p>
            </div>

            <div className="mt-10 pt-6 border-t border-[var(--ld-border)]/70">
              <p className="font-serif-display text-2xl text-[var(--ld-ink)]">
                With love,
              </p>
              <p className="font-accent text-[11px] tracking-[0.3em] uppercase text-[var(--ld-gold-deep)] mt-2">
                Founder · Luxé Directory
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </PageShell>
);

export default Founder;
